import { useQuery } from '@tanstack/react-query';
import { fetchMe, type Me } from '../api';

export function useMe() {
    return useQuery<Me>({
        queryKey: ['me'],
        queryFn:  fetchMe,
        retry:    false,
    });
}
